var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-submenu',{ref:"subMenu",attrs:{"index":_vm.item.path,"popper-append-to-body":false}},[_c('template',{slot:"title"},[_c('span',{on:{"click":function($event){return _vm.handleClick(_vm.item.path)}}},[_vm._v(_vm._s(_vm.item.name))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }